/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignAuthSupportsToSubscriptionCustom } from '../fn/subscriptions/assign-auth-supports-to-subscription-custom';
import { AssignAuthSupportsToSubscriptionCustom$Params } from '../fn/subscriptions/assign-auth-supports-to-subscription-custom';
import { createAuthSupportCustom } from '../fn/authorization-supports/create-auth-support-custom';
import { CreateAuthSupportCustom$Params } from '../fn/authorization-supports/create-auth-support-custom';
import { exportSubscriptionAuthSupportsCustom } from '../fn/authorization-supports/export-subscription-auth-supports-custom';
import { ExportSubscriptionAuthSupportsCustom$Params } from '../fn/authorization-supports/export-subscription-auth-supports-custom';
import { transferAuthSupportsToSubscriptionCustom } from '../fn/subscriptions/transfer-auth-supports-to-subscription-custom';
import { TransferAuthSupportsToSubscriptionCustom$Params } from '../fn/subscriptions/transfer-auth-supports-to-subscription-custom';
import { updateAuthSupportCustom } from '../fn/authorization-supports/update-auth-support-custom';
import { UpdateAuthSupportCustom$Params } from '../fn/authorization-supports/update-auth-support-custom';


/**
 * All about the authorization supports (badges, license plates..)
 */
@Injectable({ providedIn: 'root' })
export class AuthorizationSupportsService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `assignAuthSupportsToSubscriptionCustom()` */
  static readonly AssignAuthSupportsToSubscriptionCustomPath = '/custom/subscriptions/{uid}/auth-supports/assign';

  /**
   * Add auth supports to a subscription.
   *
   * Add auth supports to a subscription, if the supports are already assigned to a subscription,
   * they will be ignored. Returns an error if one the auth supports' plate number
   * is already use by one of the subscription's other auth supports.
   * Also propagates the subscription's default values to the auth supports.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignAuthSupportsToSubscriptionCustom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignAuthSupportsToSubscriptionCustom$Response(params: AssignAuthSupportsToSubscriptionCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignAuthSupportsToSubscriptionCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Add auth supports to a subscription.
   *
   * Add auth supports to a subscription, if the supports are already assigned to a subscription,
   * they will be ignored. Returns an error if one the auth supports' plate number
   * is already use by one of the subscription's other auth supports.
   * Also propagates the subscription's default values to the auth supports.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignAuthSupportsToSubscriptionCustom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignAuthSupportsToSubscriptionCustom(params: AssignAuthSupportsToSubscriptionCustom$Params, context?: HttpContext): Observable<void> {
    return this.assignAuthSupportsToSubscriptionCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `transferAuthSupportsToSubscriptionCustom()` */
  static readonly TransferAuthSupportsToSubscriptionCustomPath = '/custom/subscriptions/{uid}/auth-supports/transfer';

  /**
   * Transfer auth supports to a subscription.
   *
   * Transfer auth supports to a subscription. Contrary to the 'assign' endpoint,
   * already assigned supports will be removed from any link they have to be assigned to the new subscription.
   * So use this endpoint with caution. Returns an error if one the auth supports' plate number
   * is already use by one of the subscription's other auth supports.
   * Also propagates the subscription's default values to the auth supports.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transferAuthSupportsToSubscriptionCustom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transferAuthSupportsToSubscriptionCustom$Response(params: TransferAuthSupportsToSubscriptionCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return transferAuthSupportsToSubscriptionCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Transfer auth supports to a subscription.
   *
   * Transfer auth supports to a subscription. Contrary to the 'assign' endpoint,
   * already assigned supports will be removed from any link they have to be assigned to the new subscription.
   * So use this endpoint with caution. Returns an error if one the auth supports' plate number
   * is already use by one of the subscription's other auth supports.
   * Also propagates the subscription's default values to the auth supports.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transferAuthSupportsToSubscriptionCustom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transferAuthSupportsToSubscriptionCustom(params: TransferAuthSupportsToSubscriptionCustom$Params, context?: HttpContext): Observable<void> {
    return this.transferAuthSupportsToSubscriptionCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportSubscriptionAuthSupportsCustom()` */
  static readonly ExportSubscriptionAuthSupportsCustomPath = '/custom/subscriptions/{uid}/auth-supports/export';

  /**
   * Export the auth supports assigned to this subscription.
   *
   * Allows to export the Subscription auth supports
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionAuthSupportsCustom()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionAuthSupportsCustom$Response(params: ExportSubscriptionAuthSupportsCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionAuthSupportsCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the auth supports assigned to this subscription.
   *
   * Allows to export the Subscription auth supports
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionAuthSupportsCustom$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionAuthSupportsCustom(params: ExportSubscriptionAuthSupportsCustom$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionAuthSupportsCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `createAuthSupportCustom()` */
  static readonly CreateAuthSupportCustomPath = '/custom/auth-supports';

  /**
   * Create a auth support.
   *
   * Create a auth support, returning an error if the auth support's plate number
   * is already use by one of the auth support's subscription's other auth supports
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAuthSupportCustom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupportCustom$Response(params: CreateAuthSupportCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAuthSupportCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a auth support.
   *
   * Create a auth support, returning an error if the auth support's plate number
   * is already use by one of the auth support's subscription's other auth supports
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAuthSupportCustom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupportCustom(params: CreateAuthSupportCustom$Params, context?: HttpContext): Observable<void> {
    return this.createAuthSupportCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateAuthSupportCustom()` */
  static readonly UpdateAuthSupportCustomPath = '/custom/auth-supports/{uid}';

  /**
   * Update an auth support.
   *
   * Update an auth support, returning an error if the auth support's plate number
   * is already use by one of the auth support's subscription's other auth supports
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAuthSupportCustom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupportCustom$Response(params: UpdateAuthSupportCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateAuthSupportCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an auth support.
   *
   * Update an auth support, returning an error if the auth support's plate number
   * is already use by one of the auth support's subscription's other auth supports
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAuthSupportCustom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupportCustom(params: UpdateAuthSupportCustom$Params, context?: HttpContext): Observable<void> {
    return this.updateAuthSupportCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
